import { render, staticRenderFns } from "./DamageAssessorCaseDocumentUploadTab.vue?vue&type=template&id=e1388a32&scoped=true"
import script from "./DamageAssessorCaseDocumentUploadTab.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseDocumentUploadTab.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCaseDocumentUploadTab.vue?vue&type=style&index=0&id=e1388a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1388a32",
  null
  
)

export default component.exports